import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-t border-amber-200 bg-amber-50 p-3.5 text-xs font-medium text-amber-800",
  role: "status"
}
const _hoisted_2 = ["href"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { supportEmail } from '@/configs';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneQuotaReachedNotice',
  props: {
    full: { type: Boolean },
    limit: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();
const visible = computed(() => props.full && props.limit !== null);

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.quota.fullNotice', { limit: _ctx.limit })) + " ", 1),
        _createElementVNode("a", {
          class: "text-primary underline",
          href: `mailto:${_unref(supportEmail)}`
        }, _toDisplayString(_unref(supportEmail)), 9, _hoisted_2),
        _cache[0] || (_cache[0] = _createTextVNode(". ", -1))
      ]))
    : _createCommentVNode("", true)
}
}

})